module.exports = __webpack_public_path__ + "static/media/install-interstate-powerfast-battery.3583d77a.svg";